import React from "react";
import DefaultLayout from "../DefaultLayout";
import ProgramTitle from "../Components/ProgramTitle";
import { PgmLine } from "./HomeStyle";

import FarmHome from "./FarmHome";
import AdminHome from "./AdminHome";
import UserHome from "./UserHome";

const Home = () => {
  const userId = localStorage.getItem("userId");
  const userDiv = localStorage.getItem("userDiv");

  return (
    <DefaultLayout>
      <ProgramTitle>메인화면</ProgramTitle>
      <PgmLine />
      {/***** 관리자 *****/}
      {userDiv === "1" && <AdminHome />}

      {/***** 농가 *****/}
      {userDiv === "2" && <UserHome />}

      {/***** 자연으로농장 *****/}
      {userDiv === "3" && <FarmHome />}
    </DefaultLayout>
  );
};

export default Home;
